import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'litbuy-spreadsheet-templates', title: 'Best LitBuy Spreadsheet Templates in 2026' },
  { id: 'how-to-use-litbuy-spreadsheet', title: 'How to Use a LitBuy Spreadsheet Effectively' },
  { id: 'litbuy-spreadsheet-vs-alternatives', title: 'Top Alternatives to LitBuy Spreadsheet' },
];

export default function FeaturesPage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['litbuy-spreadsheet-features']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}